import { render, staticRenderFns } from "./KokiFloodReleaseSupportInfo.vue?vue&type=template&id=78cd1d84&scoped=true"
import script from "./KokiFloodReleaseSupportInfo.vue?vue&type=script&lang=ts"
export * from "./KokiFloodReleaseSupportInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78cd1d84",
  null
  
)

export default component.exports